export default {
	VENDORS: 'companies/:company_id/vendors/'
}
